import { Text, Grid, Box, IconButton } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEdit } from '@fortawesome/pro-regular-svg-icons';

import SectionStartTemplate from '../../../templates/sectionStart';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { useTranslation } from "react-i18next";

function PersonalIntro() {
    const { t } = useTranslation('common');
  const { navigateBackward, navigateForward, navigateToStudentDashboard } = useCustomNavigate();

  const onPrevious = () => navigateBackward();
  const onNext = () => navigateForward();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      hideProgress={true}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
      proceedLabel="Begin"
      section="How to use this form"
    >
      <Grid
        templateColumns="1fr auto"
        columnGap={4}
        rowGap={8}
        mb={8}
        px={{ base: 4, md: 8 }}
        py={{ base: 4, md: 8 }}
        bgColor="chakra-subtle-bg"
        borderRadius="xl"
      >
        <Box fontSize="lg">
          {t('common:ifYourInformationIsCorrect')} <b>{t('common:approveItWithTheTickButton')}</b>:
        </Box>

        <IconButton
          aria-label={t('common:confirmExampleNotInteractive')}
          size="lg"
          icon={<FontAwesomeIcon icon={faCheck} />}
          pointerEvents="none"
        />

        <Box fontSize="lg">
          {t('common:ifItIsIncorrect')} <b>{t('common:clickEditToChangeIt')}</b> {t('common:andMoveOn')}
                          </Box>

        <IconButton
          aria-label={t('common:editExampleNotInteractive')}
          size="lg"
          icon={<FontAwesomeIcon icon={faEdit} />}
          pointerEvents="none"
        />
      </Grid>

      <Text fontSize="lg">
        <b>{t('common:youWillAlsoBeAskedSomeNewQuestio')}</b>{t('common:pleaseAnswerAccurately')}
                    </Text>
    </SectionStartTemplate>
  );
}

export default PersonalIntro;
